import {
  Button,
  colors,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeading,
  TableRow,
} from '@insurancemenu/imenu-components-lib';
import styled, { css, CSSProp } from 'styled-components';
import { boxShadows } from '@insurancemenu/imenu-components-lib/dist/utils';
import { ProductLineCardStatus } from 'store/pages/rfq/initiate-rfq/pick-carriers/pageStore';

export const ProductLineCardStyled = styled.li<{ $status: ProductLineCardStatus }>`
  padding: 3rem 2.5rem;
  background-color: ${colors.neutral.white};
  border-radius: 0 0 0.4rem 0.4rem;
  box-shadow: ${boxShadows.dark[4]};

  ${({ $status }): CSSProp => {
    switch ($status) {
      case ProductLineCardStatus.INCLUDED_IN_REQUEST:
        return css`
          border-top: 1rem solid ${colors.green[600]};
        `;
      case ProductLineCardStatus.MISSING_RECIPIENTS:
        return css`
          border-top: 1rem solid ${colors.red[600]};
        `;
      case ProductLineCardStatus.NO_CARRIERS_REQUESTED:
      default:
        return css`
          border-top: 1rem solid ${colors.neutral[200]};
        `;
    }
  }};
`;

export const CardHeaderStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ProductLineButtonStyled = styled(Button)`
  font-weight: 700;
`;

export const StatusTagStyled = styled.div<{ $status: ProductLineCardStatus }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 16.5rem;
  border-radius: 1.6rem;
  padding: 0.4rem 1rem;
  font-size: 1.4rem;
  line-height: 2rem;

  ${({ $status }): CSSProp => {
    switch ($status) {
      case ProductLineCardStatus.INCLUDED_IN_REQUEST:
        return css`
          background-color: ${colors.green[600]};
          color: ${colors.neutral.white};
        `;
      case ProductLineCardStatus.MISSING_RECIPIENTS:
        return css`
          background-color: ${colors.red[600]};
          color: ${colors.neutral.white};
        `;
      case ProductLineCardStatus.NO_CARRIERS_REQUESTED:
      default:
        return css`
          background-color: ${colors.neutral[200]};
          color: ${colors.neutral[900]};
        `;
    }
  }};
`;

export const ManageContactsButtonStyled = styled(Button)`
  text-transform: uppercase;
`;

export const LogoWrapperStyled = styled.div`
  height: 2.4rem;
  max-width: 100%;
  display: flex;
  align-items: center;
`;

export const LogoStyled = styled.img`
  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
`;

export const RecipientsListStyled = styled.ul`
  padding: 0;
  list-style: none;
`;

export const CheckboxWrapperStyled = styled.div`
  & svg {
    width: 2.2rem;
    height: 2.2rem;
  }
`;

export const LabelStyled = styled.span`
  line-height: 2.8rem;
`;

// Table styles
export const TableWrapperStyled = styled.div<{ $isSectionClosed: boolean }>`
  border: 0.1rem solid ${colors.neutral[300]};
  border-radius: 1rem;
  color: ${colors.neutral[900]};
  overflow: hidden;
  transition: 0.3s ease;

  ${({ $isSectionClosed }): CSSProp =>
    $isSectionClosed
      ? `
        opacity: 0;
        margin-top: 0;
      `
      : `
        opacity: 1;
        margin-top: 3rem;
      `}
`;

export const TableStyled = styled(Table)`
  width: max(100%, 80rem);
`;

export const TableHeaderStyled = styled(TableHeader)`
  padding: 0 0.8rem;
  box-sizing: border-box;
`;

export const TableBodyStyled = styled(TableBody)`
  max-height: fit-content;
  padding: 0 0.8rem;
  box-sizing: border-box;
`;

export const TableRowStyled = styled(TableRow)`
  border-bottom: 0.1rem solid ${colors.neutral[300]};

  &:last-of-type {
    border-bottom: none;
  }
`;

export const LogoCellStyled = styled(TableCell)`
  padding-right: 2rem;
`;

export const LogoHeadingStyled = styled(TableHeading)`
  padding-right: 2rem;
`;

export const RecipientsErrorStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: ${colors.red[600]};
  font-size: 1.6rem;
`;
